import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Modal } from '@cimpress/react-components';

import { FFS_EMAIL_ADDRESS } from '../../../constants/appConstants';
import { actions as subsActions, selectors as subsSelectors } from '../../../reducers/subscriptions';
import { withSnackbar } from '../../snackbar/Snackbar';
import { withTranslation } from 'react-i18next';

class AuthorizationFlow extends PureComponent {
  static propTypes = {
    redirectUri: PropTypes.string.isRequired
  };

  state = {
    closeModal: false
  };

  componentDidMount() {
    this.props.checkAuthorization();
  }

  onCloseModal = () => {
    this.setState({ closeModal: false });
  };

  render() {
    const { isLoading, isAuthorized, hasError, t } = this.props;
    const { closeModal } = this.state;

    const authErrorMsg = (
      <p>
        {t('authorizationFlow:authErrorMessage1')}
        <br />
        {t('authorizationFlow:authErrorMessage2', { FFS_EMAIL_ADDRESS })}
      </p>
    );

    const authDescription = (
      <p>
        {t('authorizationFlow:descriptionMessage1')}
        <br />
        <br />
        {t('authorizationFlow:descriptionMessage2')}
        <strong>{t('authorizationFlow:descriptionMessage3')}</strong>
        {t('authorizationFlow:descriptionMessage4')}
        <br />
        <br />
        {t('authorizationFlow:descriptionMessage5')}
        <strong> {t('common:commonWords:authorize')}</strong> {t('authorizationFlow:descriptionMessage6')}
      </p>
    );

    const authFooter = (
      <div>
        {hasError ? <button className="btn btn-default">{t('common:commonWords:close')}</button> : null}
        <button className="btn btn-primary" disabled={hasError} onClick={this.props.authorize}>
          {t('common:commonWords:authorize')}
        </button>
      </div>
    );

    return (
      <Modal
        show={!isLoading && !isAuthorized && !closeModal}
        bsStyle={hasError ? 'danger' : 'info'}
        closeButton={hasError}
        onRequestHide={this.onCloseModal}
        closeOnOutsideClick={hasError}
        footer={authFooter}
        title={
          <h3 className="modal-title">{hasError ? t('authorizationFlow:errorTitle') : t('authorizationFlow:title')}</h3>
        }>
        {hasError ? authErrorMsg : authDescription}
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  isLoading: subsSelectors.getIsAuthLoading(state),
  isAuthorized: subsSelectors.getIsAuthorized(state),
  hasError: subsSelectors.getHasAuthError(state)
});

const mapDispatchToProps = {
  checkAuthorization: subsActions.checkNotificationAuthorization,
  authorize: subsActions.authorizeNotification
};

export default withSnackbar(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withTranslation()(AuthorizationFlow))
);
